import React from 'react';

import { ProductExtraDescriptionList } from '@domains/pdp-common';

import { ExtraDescription } from '../components/ExtraDescription';
import { useExtraDescriptionService } from '../services/useExtraDescriptionService';

export interface ExtraDescriptionContainerProps {
  extra_description_list: ProductExtraDescriptionList[] | null;
  display_description_key: string;
  style?: React.CSSProperties;
}
export const ExtraDescriptionContainer: React.FC<React.PropsWithChildren<ExtraDescriptionContainerProps>> = ({
  extra_description_list,
  display_description_key,
  style,
}) => {
  const { is_hide, content } = useExtraDescriptionService({ extra_description_list, display_description_key });

  if (is_hide) {
    return null;
  }
  return <ExtraDescription content={content} style={style} />;
};
